module.exports = __webpack_public_path__ + "static/media/startup-bg-left.c83dc045.jpg";